import React from "react";

const NotFound: React.FC = () => {
  return <div>404 not Found</div>;
};

export default NotFound;
